import type { IModule } from 'redux-state/layout/types.js';

/** Used to set default title for TitleBodyHeaderV2 */
export const setDefaultTitle = <T extends IModule['config']>(props: T, defaultTitle: string): T => {
  return { ...props, ...{ title: props.title ?? defaultTitle } };
};
